import client from "./client.js";

export async function fetchSlackInstallation() {
  const res = await client.get("/slack/installation");
  return res.data.data;
}

export async function fetchSlackAuthorizeUrl() {
  const res = await client.get("/slack/oauth/start");
  return res.data.data.url;
}

export async function updateSlackInstallation(data) {
  const res = await client.patch("/slack/installation", data);
  return res.data.data;
}

export async function deleteSlackInstallation() {
  await client.delete("/slack/installation");
}
